"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    stepTitle: {
        id: 'registration.phone.stepTitle',
        defaultMessage: 'Phone number',
        description: 'Registration phone step title',
    },
    mobileTitle: {
        id: 'registration.phone.mobileTitle',
        defaultMessage: 'Mobile Phone number',
        description: 'Registration mobile phone title',
    },
    officeTitle: {
        id: 'registration.phone.officeTitle',
        defaultMessage: 'Office Phone number',
        description: 'Registration office phone title',
    },
    title: {
        id: 'registration.phone.title',
        defaultMessage: 'Phone number',
        description: 'Registration phone title',
    },
    description: {
        id: 'registration.phone.description',
        defaultMessage: 'Please enter your phone number.',
        description: 'Registration phone description',
    },
});
exports.default = messages;
